import { Eye, EyeOff } from 'lucide-react';
import { useState } from 'react';

import { cn } from '@/lib/utils';

interface PasswordInputProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  hasError?: boolean;
  className?: string;
}

export function PasswordInput({ id, value, onChange, placeholder, disabled, hasError, className }: PasswordInputProps) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className='relative'>
      <input
        id={id}
        type={isVisible ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className={cn(
          'w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent pr-12',
          hasError ? 'border-red-500' : 'border-gray-300',
          disabled && 'opacity-50 cursor-not-allowed',
          className,
        )}
      />
      <button
        type='button'
        onClick={() => setIsVisible(!isVisible)}
        disabled={disabled}
        className='absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 disabled:opacity-50'
        tabIndex={-1}>
        {isVisible ? <EyeOff className='w-5 h-5' /> : <Eye className='w-5 h-5' />}
      </button>
    </div>
  );
}
